const arrowInsetPixels = 12;
const arrowSquareWidthPixels = 16;
const arrowApex = 8;
const arrowWidthPixels = Math.sqrt(Math.pow(arrowSquareWidthPixels, 2) * 2);

export {
  arrowInsetPixels,
  arrowWidthPixels,
  arrowApex
};

const zIndexAboveBootstrapComponents = 2000;

let styles = {
  source: {
    cursor: 'pointer',
  },
  container: {
    calculate({ top, left }) {
      let positionStyles = {};
      if (top !== null) {
        positionStyles.top = `${top}px`;
      }
      if (left !== null) {
        positionStyles.left = `${left}px`;
      }
      return Object.assign(
        {},
        styles.container.common,
        positionStyles
      );
    },
    common: {
      position: 'absolute',
      maxWidth: '400px',
      zIndex: zIndexAboveBootstrapComponents + 10,
      backgroundColor: '#FFFFFF',
      borderRadius: '2px',
      textAlign: 'left',
      whiteSpace: 'normal',
      boxShadow: '0px 3px 3px rgba(0%, 0%, 0%, 0.16)',
      border: 'solid 1px #E0E0E0',
    },
  },
  arrow: {
    calculate(edge, side) {
      let position = {};
      position[edge] = `-${arrowApex}px`;
      position[side] = `${arrowInsetPixels}px`;

      return Object.assign(
        {},
        styles.arrow.common,
        position
      );
    },
    common: {
      height: `${arrowSquareWidthPixels}px`,
      width: `${arrowSquareWidthPixels}px`,
      transform: 'rotate(45deg)',
      position: 'absolute',
      backgroundColor: '#FFFFFF',
      border: 'solid 1px #E0E0E0',
      boxShadow: '0px 3px 3px rgba(0%, 0%, 0%, 0.16)'
    },
  },
  inner: {
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontWeight: 'regular',
    padding: '12px',
    backgroundColor: '#FFFFFF',
    color: '#424242',
    fontSize: '14px',
    position: 'relative',
    borderRadius: '2px',
  }
};

export default styles;
